/**
 * Max time to wait for connectivity on cold boot (e.g. Bravia kiosk autostart).
 * Kept well below BLANK_SCREEN_CHECK_DELAY_MS (blankScreenRecovery.ts) — some TV
 * WebViews report navigator.onLine incorrectly and never fire the 'online' event,
 * so this must resolve before the blank-screen reload fires or the app can never
 * get past this wait.
 */
export const ONLINE_WAIT_TIMEOUT_MS = 5_000

/**
 * Resolves when the browser reports network connectivity.
 * On cold boot, kiosk devices may load the page before Wi‑Fi/Ethernet is ready.
 * If still offline after `timeoutMs`, resolves anyway so auth can fail gracefully.
 */
export function waitForOnline(timeoutMs: number = ONLINE_WAIT_TIMEOUT_MS): Promise<void> {
	if (typeof navigator !== 'undefined' && navigator.onLine) {
		return Promise.resolve()
	}

	return new Promise((resolve) => {
		const cleanup = (): void => {
			window.removeEventListener('online', onOnline)
			window.clearTimeout(timerId)
		}

		const onOnline = (): void => {
			cleanup()
			resolve()
		}

		const onTimeout = (): void => {
			cleanup()
			console.warn('[infoboard] Timed out waiting for network — proceeding anyway')
			resolve()
		}

		window.addEventListener('online', onOnline)
		const timerId = window.setTimeout(onTimeout, timeoutMs)
	})
}
